import styles from "../Projects/Projects.module.css";
import React from "react";
import Box from "../../components/Box/Box";
import angular from "../../assets/images/angular.png";
import reactImage from "../../assets/images/react.png";
import jsImage from "../../assets/images/js.png";
import mongoDb from "../../assets/images/mongo.png";
import userImage from "../../assets/images/users.png";

function Proyectos()
{
  return (
    <>
      <div className={styles.imgLang} id="projects">
        <div className={styles.languages}>

    
        {/* react */}
        <div className={styles.imgCircle}>
        <img src={mongoDb} className={styles.center} alt="mongodb" width={60} />
        </div>
        <div className={styles.imgCircle}>
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Node.js_logo.svg/2560px-Node.js_logo.svg.png"
          className={styles.center}
          alt="nodejs"
          width={60}
          
        />
        </div>
        <div className={styles.imgCircle}>

        <img
          className={styles.center}
          alt="react"
          width={60}
          src={reactImage}
        />
           </div>
           <div className={styles.imgCircle}>
        <img alt="angular" className={styles.center} width={60} src={angular} />
        </div>
        <div className={styles.imgCircle}>
        <img
          alt="mysql"
          className={styles.center}
          width={60}
          src="https://1000marcas.net/wp-content/uploads/2020/11/MySQL-logo.png"
        />
        </div>
        <div className={styles.imgCircle}>
        <img alt="js" className={styles.center} width={40} src={jsImage} />
      </div>
      </div>
      </div>
      <div className={styles.types}>
        {" "}
        <Box
          alt="ecommerce"
          github={"https://github.com/barbiwonderland/e-commerc"}
          page={"https://heuristic-wilson-f72502.netlify.app/"}
          image={
            "https://www.lluviadigital.com/wp-content/uploads/2020/02/e-commerce-que-es-Lluvia-Digital.jpg"
          }
        />
        <Box
          alt="todo app"
          github={"https://github.com/barbiwonderland/ReduxTodo"}
          page={"https://wonderful-goldberg-06f8ff.netlify.app/"}
          image={
            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQyakTJMd3IhL02GSm70zLJ_vOWNZA1jNjTMxtCe6mCsblQ5QDFm_Ia4htrfXJsE8SeKO0&usqp=CAU"
          }
        />
        <Box
          alt="movie searcher"
          github={"https://github.com/barbiwonderland/MovieSearcher"}
          page={"https://sharp-fermi-d0907b.netlify.app/"}
          image={
            "https://st.depositphotos.com/1555678/1276/i/600/depositphotos_12766135-stock-photo-3d-cinema-clapper-film-reel.jpg"
          }
        />
        <Box
          alt="superhero app"
          github={"https://github.com/barbiwonderland/ProyectoSuperheroes"}
          page={"https://superheroproject.netlify.app/"}
          image={
            "https://static.vecteezy.com/system/resources/previews/000/156/613/large_2x/kids-boys-and-girls-wearing-superheroes-costumes-vector.jpg"
          }
        />{" "}
        <Box
          alt="wallet"
          github={"https://github.com/barbiwonderland/AngularWallet"}
          page={"https://angularhomebanking.netlify.app/"}
          image={
            "https://cdn1.vectorstock.com/i/1000x1000/27/70/modern-online-banking-vector-20452770.jpg"
          }
        />
        <Box
          alt="ecommerce"
          github={"https://github.com/barbiwonderland/Angular-Ecommerce"}
          page={"https://angularwondercommerce.netlify.app"}
          image={
            "https://res.cloudinary.com/dte7upwcr/image/upload/blog/blog2/guia-para-ecommerce/image_0-guia-basica-para-ecommerce.png"
          }
        />{" "}
        <Box
          alt="mern"
          github={"https://github.com/barbiwonderland/mern"}
          page={"https://merapusuarios.netlify.app"}
          image={userImage}
        />
        <Box
          alt="weather app"
          github={"https://github.com/barbiwonderland/App-Clima"}
          page={"https://climabybarbi.netlify.app/"}
          image={
            "https://img.freepik.com/vector-gratis/ilustracion-pegatinas-meteorologicas-kawaii_52683-66283.jpg?w=740&t=st=1640334350~exp=1650334950~hmac=99acf14fa46519d0510a1abfd9d3aab28ec05403dfbc7cd6f19c9476f7fae154"
          }
        />
        {/* <Box
          alt="App administrable"
          github={
            "https://github.com/barbiwonderland/ProyectoFullStackNode-codoacodo"
          }
          page={
            "https://proyectofullstacknode-codoacodo-production.up.railway.app"
          }
          image={require("../../assets/images/chicacelu.png")}
        /> */}
      </div>
    </>
  );
}

export default Proyectos;
